// @flow

import 'styles/css/Home.css';
import React, { useEffect, useContext } from 'react';
import styled from 'styled-components';
import HomieContext from 'HomieContext';
import qs from 'qs';
import View from 'components/authentication/sign_in/View';
import HomeApplicationActions from 'actions/HomeApplicationActions';
import HomeApplicationStore from 'stores/HomeApplicationStore';
import { Auth } from 'utils/ExportCommon';
import { Wrapper, LeftSide, RightSide, RowBody } from 'styles/auth/style';
import { Link, withRouter } from 'react-router-dom';

const DivLabel = styled.div`
  text-align: center;
`;

const Label = styled.label`
  font-size: 16px;
  height: 24px;
  color: #4a4a4a;
  line-height: 24px;
  font-weight: 500;
  margin-bottom: 20px;
`;

const StyledLink = styled(Link)`
  width: 182px;
  color: #278c7e;
  font-size: 16px;
  &:hover {
    color: #278c7e;
  }
`;

type PropsType = {
  location: any,
  history: any
};

const Index = ({ location, history }: PropsType) => {
  const { currentUser, hideLoadingProcessView } = useContext(HomieContext);

  useEffect(() => {
    window.scrollTo(0, 0);
    if (currentUser.authenticated) {
      allowRedirect();
    }

    return () => {
      hideLoadingProcessView();
    };
  }, []);

  const redirectPath = (redirect: string, full: boolean): void => {
    document.location.href = `${full ? '' : '/h'}${redirect}`;
  };

  const allowRedirect = (): void => {
    const { home_id, return_to, redirect_url, utm_medium, campaign } = qs.parse(
      location.search,
      {
        ignoreQueryPrefix: true
      }
    );

    if (redirect_url) {
      window.location.href = redirect_url;
      return;
    }

    if (return_to) {
      redirectPath(return_to);
      return;
    }

    if (home_id) {
      HomeApplicationActions.createHomeApplication(
        {
          home_application: {
            home_id,
            utm_medium,
            campaign
          }
        },
        () => {
          const homeApplication = HomeApplicationStore.getHomeApplication();
          redirectPath(
            `/inquilino/aplicaciones/${homeApplication.id}/editar/aplicar`
          );
          return;
        }
      );
    }

    const rolesList = currentUser.roles.some(role =>
      ['owner', 'agency', 'agent'].includes(role)
    );

    if (rolesList) {
      currentUser.has_rented_active_or_started_home
        ? redirectPath('/propietario/inmuebles')
        : redirectPath('/propietario/registra-tu-inmueble', true);
      return;
    }

    const path = currentUser.has_rented_active_or_started_home
      ? '/inquilino/pagos/rentas'
      : '/usuario/bienvenido';
    redirectPath(path);
    return;
  };

  return (
    <Wrapper>
      <LeftSide>
        <RowBody>
          <View align maxfontsize={20} handleRedirect={allowRedirect} />
          <DivLabel>
            <Label>
              ¿No tienes cuenta?,{' '}
              <StyledLink to={'/registro/inquilino' + location.search}>
                regístrate
              </StyledLink>{' '}
              en Homie.
            </Label>
          </DivLabel>
        </RowBody>
      </LeftSide>
      <RightSide>
        <img className="image-cover" src={Auth.cover} />
      </RightSide>
    </Wrapper>
  );
};

export default withRouter(Index);
